import React from 'react'
import Style from './updates.module.css'
import WelcomeHero from './Components/WelcomeHero'
import AtAGlance from './Components/AtAGlance'
import GettingStarted from './Components/GettingStarted'
import QuickLinks from './Components/QuickLinks'
import PopularSystems from './Components/PopularSystems'
import { useGetConnectionsQuery } from '../../../features/connections/connectionsApi'

const EMPTY = []

const Updates = () => {
    const { data: connections = EMPTY, isLoading, isSuccess } = useGetConnectionsQuery()

    return (
        <div className="main-content newMyProducts">
            <div className="page-content pb-0">
                <div className={`container-fluid ${Style.page}`}>
                    <WelcomeHero />
                    {isLoading ? <span className={Style.skeleton} style={{ height: 150 }} aria-hidden="true" /> : null}
                    {isSuccess && connections.length > 0 ? <AtAGlance connections={connections} /> : null}
                    {isSuccess && connections.length === 0 ? <GettingStarted /> : null}
                    <QuickLinks />
                    <PopularSystems />
                </div>
            </div>
        </div>
    )
}

export default Updates
